import { createContext, useContext } from "react";

// Per-mount shadow/portal container — see index.js's mountApp. Radix
// components that portal to document.body by default (eg. Select,
// Tooltip) need this to portal back inside the widget's own container
// instead: document.body sits outside #nucar-next-widget, so Tailwind's
// `important: '#nucar-next-widget'` scoping never matches anything
// portaled straight to the body — shadow root or not — and it renders
// fully unstyled. null only in the #root fallback dev path (manual local
// testing with no #nucar-next-widget markup at all).
//
// This used to be a shared mutable singleton (`{ current: null }`), which
// broke as soon as a page had more than one widget instance mounted at
// once (eg. the bar + modal handoff pattern) — the second mount's call to
// setShadowContainer silently repointed every *other* instance's Select/
// Tooltip portals at its own container. Context scopes the value to each
// <App> tree instead, so concurrent instances can't clobber each other.
const ShadowContainerContext = createContext(null);

export const ShadowContainerProvider = ShadowContainerContext.Provider;

export function useShadowContainer() {
  return useContext(ShadowContainerContext);
}
